import React, { useState } from "react";
import PropTypes from "prop-types";
import JobDetails from "./JobDetail";

const NewJobs = ({ jobsToList, claimJobHandler }) => {
  const [expandedJobs, setExpandedJobs] = useState(new Set());

  const toggleJob = (orderNumber) => {
    setExpandedJobs((prev) => {
      const next = new Set(prev);
      next.has(orderNumber) ? next.delete(orderNumber) : next.add(orderNumber);
      return next;
    });
  };

  return (
    <div className="row">
      <div className="col-md-12">
        {jobsToList.length === 0 ? (
          <h4>There are currently no jobs to display</h4>
        ) : (
          jobsToList.map((job) => {
            const isExpanded = expandedJobs.has(job.orderNumber);
            return (
              <div key={job.orderNumber} className="card mb-3">
                <div
                  className="card-header"
                  onClick={() => toggleJob(job.orderNumber)}
                  style={{ cursor: "pointer" }}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <span style={{ fontSize: "0.9rem" }}>Ref: {job.orderNumber}</span>
                    <div className="d-flex align-items-center gap-2">
                      <span className="fw-bold" style={{ fontSize: "0.9rem" }}>
                        Job Value:{" "}
                        {new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" }).format(
                          job.engineerTotal
                        )}
                      </span>
                      <span style={{ fontSize: "0.8rem" }}>{isExpanded ? "▲" : "▼"}</span>
                    </div>
                  </div>
                  <div className="d-flex flex-column flex-md-row align-items-md-center mt-2">
                    <div className="d-flex flex-wrap gap-3 me-md-auto">
                      <span style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
                        <span className="text-muted">Install: </span>
                        {new Intl.DateTimeFormat("en-GB", { day: "2-digit", month: "short", year: "numeric" }).format(
                          new Date(job.installDate)
                        )}
                      </span>
                      <span style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
                        <span className="text-muted">Postcode: </span>
                        {job.address.postcode}
                      </span>
                    </div>
                    <div className="d-grid d-md-block mt-2 mt-md-0">
                      <button
                        className="btn btn-success btn-sm"
                        value={job.orderNumber}
                        onClick={(e) => {
                          e.stopPropagation();
                          claimJobHandler(e);
                        }}
                      >
                        Assign Job
                      </button>
                    </div>
                  </div>
                </div>
                {isExpanded && (
                  <JobDetails job={job} options={{ showPersonalInfo: false }} />
                )}
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

NewJobs.propTypes = {
  jobsToList: PropTypes.array.isRequired,
  claimJobHandler: PropTypes.func.isRequired,
};

export default NewJobs;
